// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__4bdjg","content":"Footer_content__1MZyl","service":"Footer_service__3hnTO","networks":"Footer_networks__2-yxH"};